<section
    *ngIf="banner"
    [innerHTML]="banner"
    class="featured"
    (click)="clickEvent('CTA Click - Button')"
></section>
